import { Component } from "react";
import "../../../../styles/css/table.scss";
import "../../../../App.css";
import apis from "../../../../Providers.Api/apis";
import { MDBDataTable } from "mdbreact";
import { handleSortTableDataDivWrapProperyArray, getAirStatus } from "../../../../Common/Helper";
import Spinner from "../../../../Components/Navigation/LoadingSpinner/Spinner";
import FormPanelInfo from "../../../../Components/Headings/FormHeading/FormPanelInfo";
import InputTextBox from "../../../../Components/Inputs/TextBox/InputTextBox";
import { appContext } from "../../../../AppContext";
import { DateTime } from "luxon";
import { Icons } from "../../../../Common/AllsvgIcons";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";


class ViewSensor extends IbssPage<IProps,IState> {

  private labels = appContext().labels;
  private session = appContext().sessionStorageProvider;
  
  state = {
    isLoading: false,
    facilityDataSort: { columnName: "", direction: "" },
    formFieldsData: [],
    fullSensorData: {
      Env_Sensor_Name: '',
      IAQ_Status: '',
      Env_Temperature: "",
      Env_Humidity: "",
      Env_Sound_Level: "",
      Env_CO: "",
      Env_CO2: "",
      Env_PM10: "",
      Env_PM25: "",
      Env_TVOC: "",
      Env_Zone_LastUpdated: ""
    }
  };

  public componentDidMount() : void {
    const { history, match }: any = this.props;
    const { sensorId } = match.params;
    this.pageTitle=this.labels.HubLabelSustainabilityAnalyticsSensors;
    if (this.session.getBuildingId() !== match.params.buildingid) {
      const temp = window.location.pathname.slice(0, window.location.pathname.lastIndexOf('/'));
      history.push(temp + "/" + this.session.getBuildingId())
    }
    this.handleGetSensorsData(sensorId);
  }
  getAirStatus(val: number): string {
    let obj: any = { 1: 'Good', 2: 'Fair', 3: 'Poor', 0: 'No Data' };
    return obj[val]
  }

  handleGetSensorsData = async (sensorId: string) => {
    this.setState({ isLoading: true })
    try {
      const response: any = await apis.getFullSensorsData(this.session.getBuildingId(), sensorId)
      this.setState({ fullSensorData: response?.data ?? {} });
      this.makeFormFields()
    } catch (error: any) {
      this.setState({
        isLoading: false,
      })
    }
  }

  makeFormFields = () => {
    let arr = [
      {
        name: 'Env_Sensor_Name',
        label: this.labels.HubLabelName,
        value: `${this.state.fullSensorData.Env_Sensor_Name}`,
        readonly: true
      },
      {
        name: 'IAQ_Status',
        label: this.labels.HubLabelStatus,
        value: `${this.state.fullSensorData.IAQ_Status}`,
        readonly: true
      },
      {
        name: 'Env_Temperature',
        label: this.labels.HubLabelTemperature,
        value: `${this.state.fullSensorData.Env_Temperature}\u00b0C`,
        readonly: true
      },
      {
        name: 'Env_Humidity',
        label: this.labels.HubLabelHumidity,
        value: `${this.state.fullSensorData.Env_Humidity}%`,
        readonly: true
      },
      {
        name: 'Env_Sound_Level',
        label: this.labels.HubLabelNoise,
        value: `${this.state.fullSensorData.Env_Sound_Level} dB`,
        readonly: true
      },
      {
        name: 'Env_CO',
        label: this.labels.HubLabelCo,
        value: `${this.state.fullSensorData.Env_CO} ppm`,
        readonly: true
      },
      {
        name: 'Env_CO2',
        label: this.labels.HubLabelCO2,
        value: `${this.state.fullSensorData.Env_CO2} ppm`,
        readonly: true
      },
      {
        name: 'Env_PM10',
        label: this.labels.HubLabelPM10,
        value: `${this.state.fullSensorData.Env_PM10} ppm`,
        readonly: true
      },
      {
        name: 'Env_PM25',
        label: this.labels.HubLabelPM25,
        value: `${this.state.fullSensorData.Env_PM25} ppm`,
        readonly: true
      },
      {
        name: 'Env_TVOC',
        label: this.labels.HubLabelTVOC,
        value: `${this.state.fullSensorData.Env_TVOC} ppm`,
        readonly: true
      },
      {
        name: 'Env_Zone_LastUpdated',
        label: this.labels.HubLabelLastUpdate,
        value: DateTime.fromISO(this.state.fullSensorData.Env_Zone_LastUpdated).toFormat("dd/MM/yyyy HH:mm"),
        readonly: true
      },
    ];

    this.setState({ isLoading: false, formFieldsData: arr })
  }

  public render(): JSX.Element
  {
    return (
      <>
            <div className="rightPanel-main-content-form">
              <div className="form-panel">
                {(this.state.isLoading || this.state.isLoading) && <Spinner />}
                <FormPanelInfo
                  formHeading={this.state.fullSensorData.Env_Sensor_Name}
                  iconSrc={Icons.SensorIcon}
                />
                <form className="form-panel-form">
                  {this.state.formFieldsData.map((obj: any, ind: number) => {
                    return (
                      <div className="row" key={ind}>
                        <InputTextBox {...obj} />
                      </div>
                    )
                  })}
                </form>
              </div>
            </div>
      </>
    );
  }
}

export interface IProps
{
}

export interface IFacilityDataSort 
{
  columnName: string;
  direction: string;
}

export interface IFullSensorData 
{
  Env_Sensor_Name: string;
  IAQ_Status: string;
  Env_Temperature: string;
  Env_Humidity: string;
  Env_Sound_Level: string;
  Env_CO: string;
  Env_CO2: string;
  Env_PM10: string;
  Env_PM25: string;
  Env_TVOC: string;
  Env_Zone_LastUpdated: string;
}

export interface IFormField 
{
  name: string;
  label: string;
  value: string;
  readonly: boolean;
}

export interface IState 
{
  isLoading: boolean;
  facilityDataSort: IFacilityDataSort;
  formFieldsData: IFormField[];
  fullSensorData: IFullSensorData;
}


export default ViewSensor;
 